import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import { Checkbox } from '@wds/checkbox';
import { FormattedNumber, t } from '@sm/intl';
import { OECSentiment } from '../../../types';
import { getSentimentIcon } from '../../../ManualTagging/Responses/ResponseCard';
import OpenEndedCodingContext from '../../../OpenEndedCodingContext';
import { useFilters, useFiltersActions } from '../../../Context';
export const COPY = {
  positive: {
    id: 'OpenEndedCoding.SentimentStats.positive',
    defaultMessage: 'Positive',
    description: '[Type: Header][Vis: med] - Positive sentiment stats'
  },
  neutral: {
    id: 'OpenEndedCoding.SentimentStats.neutral',
    defaultMessage: 'Neutral',
    description: '[Type: Header][Vis: med] - Neutral sentiment stats'
  },
  negative: {
    id: 'OpenEndedCoding.SentimentStats.negative',
    defaultMessage: 'Negative',
    description: '[Type: Header][Vis: med] - Negative sentiment stats'
  },
  undetected: {
    id: 'OpenEndedCoding.SentimentStats.undetected',
    defaultMessage: 'Unknown',
    description: '[Type: Header][Vis: med] - Undetected sentiment stats'
  }
};
const getSentimentPercentage = ({
  saCount,
  totalSaCounts
}) => {
  if (totalSaCounts === 0) {
    return 0;
  }
  return saCount / totalSaCounts;
};
export const SentimentRow = ({
  sentiment,
  saCount,
  totalSaCounts
}) => {
  const {
    filterResponses
  } = useContext(OpenEndedCodingContext);
  const sentimentCopy = {
    [OECSentiment.SM_POSITIVE]: t(COPY.positive),
    [OECSentiment.SM_NEGATIVE]: t(COPY.negative),
    [OECSentiment.SM_NEUTRAL]: t(COPY.neutral),
    [OECSentiment.SM_UNDETECTED]: t(COPY.undetected)
  };
  const {
    setSelectedSentiment
  } = useFiltersActions();
  const {
    selectedSentiment,
    searchInput,
    sortValue,
    filterByTaggedStatus
  } = useFilters();
  return _jsxs(Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mb: 4,
    children: [_jsxs(Box, {
      display: "flex",
      alignItems: "center",
      children: [_jsx(Checkbox, {
        id: `${sentiment}-sentimentCheckbox`,
        "data-testid": `${sentiment}-sentimentCheckbox`,
        value: sentiment,
        checked: selectedSentiment.includes(sentiment),
        onChange: e => {
          const newSentiments = e.target.checked ? [...selectedSentiment, sentiment] : selectedSentiment.filter(s => s !== sentiment);
          filterResponses({
            sentiments: newSentiments,
            search: searchInput,
            sortBy: sortValue,
            filterByTaggedStatus: filterByTaggedStatus
          });
          setSelectedSentiment(newSentiments);
        }
      }), _jsx(Box, {
        mx: 3,
        pb: 1,
        children: getSentimentIcon(sentiment)
      }), _jsx(Typography, {
        component: "span",
        variant: "bodySm",
        children: sentimentCopy[sentiment]
      })]
    }), _jsxs(Box, {
      display: "flex",
      justifyContent: "flex-end",
      children: [_jsx(Box, {
        mr: 4,
        children: _jsx(Typography, {
          component: "span",
          variant: "bodySm",
          weight: "medium",
          children: _jsx(FormattedNumber, {
            formatStyle: "percent",
            value: getSentimentPercentage({
              saCount,
              totalSaCounts
            })
          })
        })
      }), _jsx(Typography, {
        component: "span",
        variant: "bodySm",
        children: saCount
      })]
    })]
  });
};